module.exports = __webpack_public_path__ + "static/media/asc-logo.d5a5b096.svg";